// Distinct colours for chart slices (partner tiers, etc.). The first 12 are
// hand-picked; beyond that we step the hue by the golden angle so no two
// slices ever repeat a colour.
const PALETTE = [
  '#3b82f6', '#22c55e', '#f97316', '#a855f7', '#14b8a6', '#ef4444',
  '#eab308', '#ec4899', '#6366f1', '#84cc16', '#06b6d4', '#92400e',
];

export function sliceColor(i) {
  if (i < PALETTE.length) return PALETTE[i];
  const hue = Math.round((i * 137.508) % 360);
  return `hsl(${hue}, 65%, 50%)`;
}

export const UNASSIGNED_COLOR = '#9ca3af';
